export default __webpack_public_path__ + "static/media/global-icon-two.fa8f2753.svg";